import { MobXProviderContext } from 'mobx-react'
import { useContext } from 'react'
import { IStore } from '~/stores'

export const useStores = () => {
  return useContext(MobXProviderContext) as { store: IStore }
}
